import { useQuery } from 'react-query';
import { useContext } from 'react';
import AuthContext from '../../store/auth-context';
import { getTimeOptionslist } from '../../api/studiesAPI';

import Select from 'react-select';
import Loader from '../ui/Loader';

const BillingGridAddTableRow = ({
	rowData,
	onRowChange,
	index,
	tableNumber,
	studyId
}) => {
	const authCtx = useContext(AuthContext);

	const { isLoading, isError, error, data } = useQuery({
		queryKey: ['list-time-options', studyId, tableNumber],
		queryFn: () => getTimeOptionslist(studyId, tableNumber),
		retry: false,
		staleTime: 3000000, //5 minutes to refetch
		enabled: !!studyId
	});
	if (isLoading) {
		return <Loader centered />;
	}

	const { dropdown } = data.data;

	const handleSponsorInput = (e) => {
		onRowChange(
			{
				weeks: rowData.weeks,
				sponsor: e.target.value
			},
			index
		);
	};
	const handleTimeInput = (selectedOptions) => {
		const useSelectedOptions = [...selectedOptions].map(
			(option) => option.value
		);

		onRowChange(
			{
				weeks: useSelectedOptions,
				sponsor: rowData.sponsor
			},
			index
		);
	};
	return (
		<tr>
			<td>
				<Select
					isMulti
					options={dropdown.map((option) => {
						return {
							value: option.Coordinates,
							label: option.Label
						};
					})}
					onChange={(selectedOptions) =>
						handleTimeInput(selectedOptions)
					}
				/>
			</td>
			<td>
				<select
					id='sponsor'
					className='form-select input-add-row'
					placeholder='Select'
					defaultValue='Select...'
					onChange={handleSponsorInput}
				>
					{' '}
					<option value=''>Select</option>
					<option value={authCtx.userData.n}>
						{authCtx.userData.n}
					</option>
					<option value={authCtx.userData.s}>
						{authCtx.userData.s}
					</option>
					<option value={authCtx.userData.nb}>
						{authCtx.userData.nb}
					</option>
				</select>
			</td>
		</tr>
	);
};

export default BillingGridAddTableRow;
